<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { RouterLink, useRoute } from 'vue-router'
import router from '@/router'
import IframeContentComponent from '@/components/IframeContentComponent.vue'
import ChartsComponent from '@/components/ChartsComponent.vue';
import FeedbackComponent from '@/components/FeedbackComponent.vue'
import {
  Bars3Icon,
  ListBulletIcon,
  XMarkIcon,
  ArrowRightOnRectangleIcon,
  UserCircleIcon,
  QuestionMarkCircleIcon,
  Cog6ToothIcon,
  BellIcon,
  ChatBubbleOvalLeftEllipsisIcon
} from '@heroicons/vue/24/outline'
import { usePermissions } from '@/stores/utils'
import { useForumStore } from '@/stores/iframes'
import { useOwncloudStore } from '@/stores/iframes'
import { useUser } from '@/stores/user'
import { userManager } from '@/oidc/plugin'
import generatedTypes from '@/components/alert/types';
import AuthService from '@/services/AuthService';
import { storeToRefs } from 'pinia';

let user: any = await userManager.getUser()

// const flarumStore = useForumStore();

const { setUser } = useUser();
const { userStore, acceptedCharte } = storeToRefs(useUser());
// const haveCheckedCharte = ref(false);

// if (user) {
//   try {
//     AuthService.getProfile().then(
//       res => {
//         if (res.status == 200) {
//           useUser().setAcceptedCharte(res.data.hasAcceptedCharte);
//           useUser().setFilledInfos(res.data.hasFilledInfos);
//           // if filledInfos is false, route reload
//         }
//         haveCheckedCharte.value = true;
//       }
//     )
//   } catch (error) {
//     haveCheckedCharte.value = true;
//     console.error(error);
//   }
// }



const iframePage = ["Forum", "Cloud", "Vidéo"]
const perm: any = usePermissions;
const route = useRoute();
const navigation = ref();
const checkIfCharteIsOk = ref(user ? acceptedCharte || localStorage.getItem('charteAccepted') : true)

const feedback = ref()


function sendMail() {
  sidebarOpen.value = false
  feedback.value.open = true
}

// watch(acceptedCharte, () => {
//   checkIfCharteIsOk.value = acceptedCharte
//   console.log('checkIfCharteIsOk2', checkIfCharteIsOk.value)
// })


watch(
  () => route.name,
  async () => {
    user = await userManager.getUser()
    let userGroups = user?.profile?.groups;
    let userPerms = userGroups ? userGroups.map((el: string) => el = perm[el]).flat() : perm.disconnected

    navigation.value = router.getRoutes().filter(el => {
      return el.meta.allowNavigation && userPerms.includes(el.meta.permission)

    })
  }
)

// watch user
watch(
  () => user,
  async () => {
    setUser(user)

  }
)


const sidebarOpen = ref(false);
const hover = ref(false);

function triggerIframeEvent() {
  let iframeForum: HTMLIFrameElement | null = document.querySelector("iframe#forum")
  if (iframeForum) {
    iframeForum.contentWindow?.postMessage(
      "openclodesidebar",
      "https://forum.profan-transfert.limos.fr"
    );
  }
}

function RedirectToCloudActivity() {
  console.log('RedirectToCloudActivity')
  let url = 'https://cloud.profan-transfert.limos.fr/apps/activity';
  let iframeCloud: HTMLIFrameElement | null = document.querySelector('iframe#cloud');
  if (iframeCloud) {

    iframeCloud.contentWindow?.location.replace(url)
  } else {
    const store = useOwncloudStore();
    store.url = url
  }
  router.push({ name: 'Cloud' })
}

function RedirectToForumActivity() {

  let url = import.meta.env.VITE_FORUM_URL + 'u/' + user?.profile?.sub + '/activity';
  let iframeForum: HTMLIFrameElement | null = document.querySelector("iframe#forum");
  if (iframeForum) {
    iframeForum.contentWindow?.postMessage(
      "activityPage",
      "https://forum.profan-transfert.limos.fr"
    );
  } else {
    const store = useForumStore();
    store.url = url
  }
  router.push({ name: 'Forum' });
}


const staticSidebar = ref();
const main = ref();
onMounted(() => {
  staticSidebar.value.addEventListener("focusin", () => {
    if (!hover.value) {
      hover.value = true
    }
  });
  main.value.addEventListener("focusin", () => {
    if (hover.value) {
      hover.value = false
    }
  });
  // checkIfCharteIsOk.value = acceptedCharte
  // console.log('checkIfCharteIsOk2', checkIfCharteIsOk.value, acceptedCharte)
})

const alertMsg = ref([] as any[])
function addAlert(type: string, message: string) {
  alertMsg.value.push({ type: type, message: message });
}

function signout() {
  userManager.signoutRedirect()
}

function signin() {
  userManager.signinRedirect()
}



</script>

<template>
  <div>

    <TransitionRoot as="template" :show="sidebarOpen">
      <Dialog as="div" class="relative z-50 lg:hidden" @close="sidebarOpen = false">
        <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0"
          enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
          leave-to="opacity-0">
          <div class="fixed inset-0 bg-gray-900/80"></div>
        </TransitionChild>

        <div class="fixed inset-0 flex">
          <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
            enter-from="-translate-x-full" enter-to="translate-x-0"
            leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
            leave-to="-translate-x-full">
            <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
              <TransitionChild as="template" enter="ease-in-out duration-300" enter-from="opacity-0"
                enter-to="opacity-100" leave="ease-in-out duration-300" leave-from="opacity-100" leave-to="opacity-0">
                <div class="absolute left-full top-0 flex w-16 justify-center pt-5">
                  <button type="button" class="-m-2.5 p-2.5" @click="sidebarOpen = false">
                    <span class="sr-only">Fermer sidebar</span>
                    <XMarkIcon class="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </TransitionChild>
              <!-- Sidebar component, swap this element with another sidebar if you like -->
              <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2">
                <div class="flex justify-center pt-3 w-full">
                  <div class="flex flex-nowrap gap-1">
                    <img class="h-full w-auto" src="/logoL.svg" alt="ProFan Transfert" />
                    <img class="h-full w-auto" src="/logoRoptimized.svg" alt="ProFan Transfert Chevron" />
                  </div>
                </div>
                <nav class="flex flex-1 flex-col">
                  <ul role="list" class="flex flex-1 flex-col gap-y-7">
                    <li>

                      <ul role="list" class="-mx-3 space-y-1 mt-0 px-2 overflow-scroll overflow-x-hidden relative">
                        <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
                        <li v-for="item in navigation" :key="String(item.name) + 'mobile_is_auth'">
                          <RouterLink :to="item.path" @click="sidebarOpen = false"
                            class=" hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                            :class="[!hover && 'w-full px-6']" active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                            <component :is="item.meta.navigationIcon"
                              class=" group-hover:text-blue-600 h-6 w-6 shrink-0 " aria-hidden="true" />
                            <span>{{ item.name }}</span>
                          </RouterLink>
                        </li>
                        <li v-if="user">
                          <a href="https://eccipe.limos.fr/" target="_blank"
                            class=" hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                            :class="[!hover && 'w-full px-6']" active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                            <svg fill="currentColor" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 "
                              aria-hidden="true" viewBox="0 0 167.59 131.41">
                              <g transform="matrix(1.3333 0 0 -1.3333 -80.765 234.45)">
                                <g transform="translate(-299.56 -64.964)">
                                  <g transform="translate(299.53 17.167)">
                                    <path
                                      d="m175.68 196.42h-14.68c-3.643 2.89-8.296 4.641-13.367 4.671 0.591-2.005 0.928-4.111 0.964-6.289 7.772-0.536 13.926-6.687 13.926-14.19 0-0.335-0.029-0.664-0.053-0.994 2.128-0.367 4.16-0.992 6.068-1.843 0.135 0.93 0.229 1.872 0.229 2.837 0 1.973-0.307 3.875-0.849 5.681l8.455 8.455c0.617 0.617 0.18 1.672-0.693 1.672" />
                                    <path
                                      d="m136.01 210.9v11.754c0 0.872-1.055 1.309-1.672 0.692l-8.581-8.581c-0.758 0.079-1.526 0.126-2.305 0.126-7.961 0-14.902-4.242-18.546-10.497 2.127-0.462 4.151-1.185 6.038-2.134 2.694 3.842 7.288 6.388 12.508 6.388 8.284 0 15.022-6.389 15.022-14.242 0-4.082-1.882-7.968-5.08-10.656-0.432-0.362-0.485-1.004-0.086-1.402l3.075-3.075c0.347-0.347 0.912-0.379 1.282-0.057 4.439 3.859 7.053 9.372 7.053 15.19 0 6.768-3.44 12.762-8.708 16.494" />
                                    <path
                                      d="m99.398 201.1c-5.126 0-9.835-1.757-13.511-4.678h-14.668c-0.873 0-1.31-1.055-0.693-1.672l8.456-8.455c-0.543-1.806-0.85-3.708-0.85-5.681 0-0.957 0.092-1.891 0.225-2.814 1.909 0.847 3.941 1.466 6.069 1.828-0.024 0.327-0.051 0.654-0.051 0.986 0 7.854 6.74 14.243 15.023 14.243 7.964 0 14.5-5.905 14.993-13.34 0.033-0.503 0.427-0.903 0.931-0.903h4.368c0.532 0 0.976 0.445 0.95 0.977-0.531 10.844-9.856 19.509-21.242 19.509" />
                                    <path
                                      d="m155.26 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m159.77 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m164.29 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m186.01 140.59-7.963 7.963c0.849 2.21 1.336 4.587 1.336 7.078 0 11.296-9.54 20.485-21.266 20.485-4.679 0-9.178-1.488-12.866-4.196-0.459-0.338-0.493-1.02-0.09-1.423l3.125-3.125c0.32-0.321 0.814-0.353 1.19-0.101 2.517 1.684 5.52 2.602 8.641 2.602 8.284 0 15.022-6.389 15.022-14.242 0-7.854-6.738-14.242-15.022-14.242-3.139 0-6.158 0.929-8.683 2.632-0.377 0.253-0.872 0.222-1.193-0.1l-3.125-3.124c-0.402-0.403-0.369-1.083 0.089-1.421 3.695-2.731 8.213-4.231 12.912-4.231 4.564 0 8.787 1.406 12.255 3.773h14.946c0.872 0 1.309 1.055 0.692 1.672" />
                                    <path
                                      d="m101.79 140.79-3.125 3.125c-0.321 0.321-0.816 0.353-1.193 0.099-2.526-1.703-5.544-2.633-8.683-2.633-8.283 0-15.022 6.389-15.022 14.243 0 7.853 6.739 14.242 15.022 14.242 3.121 0 6.124-0.918 8.641-2.602 0.377-0.252 0.87-0.22 1.191 0.101l3.125 3.124c0.403 0.404 0.368 1.086-0.091 1.423-3.688 2.709-8.187 4.197-12.866 4.197-11.725 0-21.266-9.189-21.266-20.485 0-2.491 0.487-4.869 1.336-7.078l-7.962-7.963c-0.617-0.617-0.181-1.672 0.692-1.672h14.945c3.468-2.367 7.691-3.773 12.255-3.773 4.699 0 9.216 1.5 12.912 4.231 0.458 0.338 0.492 1.018 0.089 1.421" />
                                    <path
                                      d="m85.745 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m90.264 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m94.782 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m120.41 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m129.45 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m124.93 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                                    <path
                                      d="m123.45 141.38c-8.283 0-15.023 6.389-15.023 14.242 0 7.854 6.74 14.243 15.023 14.243 8.284 0 15.023-6.389 15.023-14.243 0-7.853-6.739-14.242-15.023-14.242m21.266 14.242c0 11.296-9.54 20.486-21.266 20.486s-21.266-9.19-21.266-20.486c0-7.584 4.311-14.203 10.685-17.744v-11.823c0-0.873 1.055-1.31 1.672-0.693l9.82 9.819c11.302 0.465 20.355 9.441 20.355 20.441" />
                                  </g>
                                </g>
                              </g>
                            </svg>
                            <span>ECC'IPE</span>
                          </a>
                        </li>
                      </ul>
                    </li>
                    <!-- <li class="-mx-6 mt-auto">
                        <a href="#" class="flex items-center gap-x-4 px-6 py-3 text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100">
                          <component :is="'ArrowRightOnRectangleIcon'" class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0" aria-hidden="true" />
                          <span class="sr-only">Your profile</span>
                          <span aria-hidden="true">Tom Cook</span>
                        </a>
                      </li> -->
                  </ul>
                  <div>













                    <button v-if="user" @click="sendMail" aria-label="Bouton de demande d'aide au support"
                      class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full cursor-pointer">
                      <component :is="QuestionMarkCircleIcon"
                        class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0" aria-hidden="true" />
                      <span aria-hidden="true"
                        class=" whitespace-nowrap overflow-hidden text-gray-500 group-hover:text-blue-600">{{ user ?
                          'Feedback' : 'Support' }}</span>

                    </button>

                    <RouterLink v-if="user" to="/profile" @click="sidebarOpen = false"
                      class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full">
                      <component :is="Cog6ToothIcon" class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0"
                        aria-hidden="true" />

                      <span aria-hidden="true"
                        class=" whitespace-nowrap overflow-ellipsis overflow-hidden group-hover:text-blue-600"> {{
                          user?.profile?.name }}</span>

                    </RouterLink>
                    <button v-if="user" aria-label="Bouton de deconnection" @click="signout"
                      class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full">
                      <component :is="ArrowRightOnRectangleIcon"
                        class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0" aria-hidden="true" />
                      <span aria-hidden="true"
                        class=" whitespace-nowrap overflow-hidden text-gray-700 group-hover:text-blue-600">Se
                        déconnecter</span>

                    </button>

                    <button v-else @click="signin" aria-label="Bouton de connection"
                      class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full">
                      <component :is="UserCircleIcon" class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0"
                        aria-hidden="true" />
                      <span aria-hidden="true"
                        class=" whitespace-nowrap overflow-hidden text-gray-700 group-hover:text-blue-600">Se
                        connecter</span>

                    </button>















                  </div>
                </nav>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <!-- Static sidebar for desktop -->
    <div ref="staticSidebar" class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col transition-all"
      :class="[!hover && 'lg:!w-16 duration-300']" @mouseover="hover = true" @mouseleave="hover = false">
      <!-- Sidebar component, swap this element with another sidebar if you like -->
      <div
        class="h-screen flex grow flex-col overflow-y-auto overflow-x-hidden border-r border-gray-200 bg-white transition-all"
        :class="[hover && 'px-6']">
        <div class="flex justify-center w-full py-3">
          <!-- <img class="h-auto w-auto" src="/logoProfan.png" alt="ProFan Transfert" /> -->
          <div class="flex flex-nowrap gap-1 h-6 px-6" :class="[!hover && 'px-0']">
            <img class="h-full w-full transition-all duration-500 delay-50"
              :class="[!hover && '!w-0 !delay-0 !duration-0']" src="/logoL.svg" alt="ProFan Transfert" />
            <img class="h-full w-auto fill-blue-600" src="/logoRoptimized.svg" alt="ProFan Transfert Chevron" width="14"
              height="24" />
          </div>
        </div>
        <nav class="flex flex-col justify-between h-full max-h-[calc(100%-4rem)] gap-2">
          <ul role="list" class="-mx-3 space-y-1 mt-0 px-2 overflow-scroll overflow-x-hidden relative py-2">
            <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
            <li v-for="item in navigation" :key="String(item.name) + 'desk_is_auth'" class="grid grid-cols-6 gap-1">

              <template v-if="item.name == 'Cloud'">
                <RouterLink :to="item.path" :id="item.name" :ariaLabel="'Bouton de navigation vers ' + item.name"
                  class=" hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                  :class="[hover ? 'col-span-5' : 'w-full px-6 col-span-full']"
                  active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                  <component :is="item.meta.navigationIcon" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 "
                    aria-hidden="true" />
                  <span v-if="hover" class=" whitespace-nowrap overflow-ellipsis overflow-hidden">{{ item.name }}</span>
                </RouterLink>
                <button v-if="hover" @click="RedirectToCloudActivity"
                  class="col-span-1 hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                  :class="[!hover && 'w-full px-6']" active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                  <component :is="BellIcon" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 " aria-hidden="true" />
                </button>
              </template>
              <template v-else-if="item.name == 'Forum'">
                <RouterLink :to="item.path" :id="item.name" :ariaLabel="'Bouton de navigation vers ' + item.name"
                  class=" hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                  :class="[hover ? 'col-span-5' : 'w-full px-6 col-span-full']"
                  active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                  <component :is="item.meta.navigationIcon" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 "
                    aria-hidden="true" />
                  <span v-if="hover" class=" whitespace-nowrap overflow-ellipsis overflow-hidden">{{ item.name }}</span>
                </RouterLink>
                <button v-if="hover" @click="RedirectToForumActivity"
                  class="col-span-1 hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                  :class="[!hover && 'w-full px-6']" active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                  <component :is="ChatBubbleOvalLeftEllipsisIcon" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 "
                    aria-hidden="true" />
                </button>
              </template>
              <template v-else>
                <RouterLink :to="item.path" :id="item.name" :ariaLabel="'Bouton de navigation vers ' + item.name"
                  class="col-span-full hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                  :class="[!hover && 'w-full px-6']" active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                  <component :is="item.meta.navigationIcon" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 "
                    aria-hidden="true" />
                  <span v-if="hover" class=" whitespace-nowrap overflow-ellipsis overflow-hidden">{{ item.name }}</span>
                </RouterLink>
              </template>
            </li>



            <li class="grid grid-cols-6 gap-1" v-if="user">
              <a href="https://eccipe.limos.fr/" target="_blank" :ariaLabel="'Bouton de navigation vers ECCIPE'"
                class="col-span-full hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                :class="[!hover && 'w-full px-6']" active-class="!text-blue-600 !fill-blue-600 bg-gray-100">
                <svg fill="currentColor" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 "
                  aria-hidden="true"
                  viewBox="0 0 167.59 131.41">
                  <g transform="matrix(1.3333 0 0 -1.3333 -80.765 234.45)">
                    <g transform="translate(-299.56 -64.964)">
                      <g transform="translate(299.53 17.167)">
                        <path
                          d="m175.68 196.42h-14.68c-3.643 2.89-8.296 4.641-13.367 4.671 0.591-2.005 0.928-4.111 0.964-6.289 7.772-0.536 13.926-6.687 13.926-14.19 0-0.335-0.029-0.664-0.053-0.994 2.128-0.367 4.16-0.992 6.068-1.843 0.135 0.93 0.229 1.872 0.229 2.837 0 1.973-0.307 3.875-0.849 5.681l8.455 8.455c0.617 0.617 0.18 1.672-0.693 1.672" />
                        <path
                          d="m136.01 210.9v11.754c0 0.872-1.055 1.309-1.672 0.692l-8.581-8.581c-0.758 0.079-1.526 0.126-2.305 0.126-7.961 0-14.902-4.242-18.546-10.497 2.127-0.462 4.151-1.185 6.038-2.134 2.694 3.842 7.288 6.388 12.508 6.388 8.284 0 15.022-6.389 15.022-14.242 0-4.082-1.882-7.968-5.08-10.656-0.432-0.362-0.485-1.004-0.086-1.402l3.075-3.075c0.347-0.347 0.912-0.379 1.282-0.057 4.439 3.859 7.053 9.372 7.053 15.19 0 6.768-3.44 12.762-8.708 16.494" />
                        <path
                          d="m99.398 201.1c-5.126 0-9.835-1.757-13.511-4.678h-14.668c-0.873 0-1.31-1.055-0.693-1.672l8.456-8.455c-0.543-1.806-0.85-3.708-0.85-5.681 0-0.957 0.092-1.891 0.225-2.814 1.909 0.847 3.941 1.466 6.069 1.828-0.024 0.327-0.051 0.654-0.051 0.986 0 7.854 6.74 14.243 15.023 14.243 7.964 0 14.5-5.905 14.993-13.34 0.033-0.503 0.427-0.903 0.931-0.903h4.368c0.532 0 0.976 0.445 0.95 0.977-0.531 10.844-9.856 19.509-21.242 19.509" />
                        <path
                          d="m155.26 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m159.77 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m164.29 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m186.01 140.59-7.963 7.963c0.849 2.21 1.336 4.587 1.336 7.078 0 11.296-9.54 20.485-21.266 20.485-4.679 0-9.178-1.488-12.866-4.196-0.459-0.338-0.493-1.02-0.09-1.423l3.125-3.125c0.32-0.321 0.814-0.353 1.19-0.101 2.517 1.684 5.52 2.602 8.641 2.602 8.284 0 15.022-6.389 15.022-14.242 0-7.854-6.738-14.242-15.022-14.242-3.139 0-6.158 0.929-8.683 2.632-0.377 0.253-0.872 0.222-1.193-0.1l-3.125-3.124c-0.402-0.403-0.369-1.083 0.089-1.421 3.695-2.731 8.213-4.231 12.912-4.231 4.564 0 8.787 1.406 12.255 3.773h14.946c0.872 0 1.309 1.055 0.692 1.672" />
                        <path
                          d="m101.79 140.79-3.125 3.125c-0.321 0.321-0.816 0.353-1.193 0.099-2.526-1.703-5.544-2.633-8.683-2.633-8.283 0-15.022 6.389-15.022 14.243 0 7.853 6.739 14.242 15.022 14.242 3.121 0 6.124-0.918 8.641-2.602 0.377-0.252 0.87-0.22 1.191 0.101l3.125 3.124c0.403 0.404 0.368 1.086-0.091 1.423-3.688 2.709-8.187 4.197-12.866 4.197-11.725 0-21.266-9.189-21.266-20.485 0-2.491 0.487-4.869 1.336-7.078l-7.962-7.963c-0.617-0.617-0.181-1.672 0.692-1.672h14.945c3.468-2.367 7.691-3.773 12.255-3.773 4.699 0 9.216 1.5 12.912 4.231 0.458 0.338 0.492 1.018 0.089 1.421" />
                        <path
                          d="m85.745 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m90.264 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m94.782 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m120.41 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m129.45 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m124.93 155.66c0-0.817-0.662-1.479-1.479-1.479s-1.479 0.662-1.479 1.479 0.662 1.479 1.479 1.479 1.479-0.662 1.479-1.479" />
                        <path
                          d="m123.45 141.38c-8.283 0-15.023 6.389-15.023 14.242 0 7.854 6.74 14.243 15.023 14.243 8.284 0 15.023-6.389 15.023-14.243 0-7.853-6.739-14.242-15.023-14.242m21.266 14.242c0 11.296-9.54 20.486-21.266 20.486s-21.266-9.19-21.266-20.486c0-7.584 4.311-14.203 10.685-17.744v-11.823c0-0.873 1.055-1.31 1.672-0.693l9.82 9.819c11.302 0.465 20.355 9.441 20.355 20.441" />
                      </g>
                    </g>
                  </g>
                </svg>
                <span v-if="hover" class=" whitespace-nowrap overflow-ellipsis overflow-hidden">ECC'IPE</span>
              </a>
            </li>



            <!-- <li v-else v-for="item in navigation" :key="item.name+'desk_not_auth'">
                    <RouterLink v-if="!item.requiredAuth" :to="item.href" class=" hover:text-blue-600 hover:bg-gray-100 text-gray-400 relative transition-all group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold" :class="[!hover && 'w-full px-6']" active-class="!text-blue-600 !fill-blue-600 bg-gray-100" >
                      <component :is="item.icon" class=" group-hover:text-blue-600 h-6 w-6 shrink-0 " aria-hidden="true"/>
                      <span v-if="hover" class=" whitespace-nowrap overflow-ellipsis overflow-hidden">{{ item.name }}</span>
                      
                    </RouterLink>
                  </li>  -->
          </ul>

          <div>

            <button v-if="user" @click="sendMail" aria-label="Bouton de demande d'aide au support"
              class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full cursor-pointer">
              <component :is="QuestionMarkCircleIcon" class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0"
                aria-hidden="true" />
              <span v-if="hover" aria-hidden="true"
                class=" whitespace-nowrap overflow-hidden text-gray-500 group-hover:text-blue-600">
                {{ user ? 'Feedback' : 'Support' }}
              </span>

            </button>

            <RouterLink v-if="user" to="/profile"
              class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full">
              <component :is="Cog6ToothIcon" class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0"
                aria-hidden="true" />

              <span v-if="hover" aria-hidden="true"
                class=" whitespace-nowrap overflow-ellipsis overflow-hidden group-hover:text-blue-600"> {{
                  user?.profile?.name }}</span>

            </RouterLink>
            <button v-if="user" aria-label="Bouton de deconnection" @click="signout"
              class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full">
              <component :is="ArrowRightOnRectangleIcon"
                class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0" aria-hidden="true" />
              <span v-if="hover" aria-hidden="true"
                class=" whitespace-nowrap overflow-hidden text-gray-700 group-hover:text-blue-600">Se déconnecter</span>

            </button>

            <button v-else @click="signin" aria-label="Bouton de connection"
              class="h-12 flex text-sm font-semibold leading-6 text-gray-900 hover:bg-gray-100 py-2 pl-5 overflow-hidden gap-3 items-center group w-full">
              <component :is="UserCircleIcon" class="text-gray-400 group-hover:text-blue-600 h-6 w-6 shrink-0"
                aria-hidden="true" />
              <span v-if="hover" aria-hidden="true"
                class=" whitespace-nowrap overflow-hidden text-gray-700 group-hover:text-blue-600">Se connecter</span>

            </button>

          </div>
        </nav>
      </div>
    </div>

    <div class=" top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden">
      <button type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden" @click="sidebarOpen = true">
        <span class="sr-only">Open sidebar</span>
        <Bars3Icon class="h-6 w-6" aria-hidden="true" />
      </button>
      <div class="flex-1 text-sm font-semibold leading-6 text-gray-900">{{ route.name }}</div>
      <a href="#" v-if="user">
        <span class="sr-only">Your profile</span>
        <img v-if="user?.profile?.images" class="h-8 w-8 rounded-full bg-gray-50 border-spacing-0"
          src="https://storage.letudiant.fr/mediatheque/educpros/7/1/586071-monteil-jean-marc-nb-160x160.jpg" alt="" />
        <div v-else
          class="h-8 w-8 min-w-[2rem] rounded-full border-spacing-0 grid place-items-center bg-blue-500 text-white cursor-default">
          {{ user?.profile?.name?.slice(0, 1) }}</div>
      </a>
      <button v-if="user && route.name == 'Forum'" type="button" class="-m-2.5 p-2.5 text-gray-700 lg:hidden"
        @click="triggerIframeEvent()">
        <span class="sr-only">Open sidebar</span>
        <ListBulletIcon class="h-6 w-6" aria-hidden="true" />
      </button>
    </div>

    <!-- :class="[iframePage.includes(String(route.name)) ? 'h-[calc(100vh_-_4rem)]' : ' min-h-screen']" -->
    <main ref="main" class="h-[calc(100vh_-_4rem)] lg:min-h-screen lg:pl-16 w-full relative scroll-smooth">
      <div id="alerts" class="lg:pl-14 w-full fixed top-14 lg:top-0 left-1/2 -translate-x-1/2 flex flex-col z-20 h-min">
        <component v-for="(value, key) in alertMsg" :is="generatedTypes.get(value.type)" :message="value.message"
          :key="key" class=" animate-notification" />

      </div>
      <slot></slot>
      <IframeContentComponent v-if="user" />
      <!-- <iframe v-else class="w-0 h-0 overflow-hidden"
              :src="flarumStore.url+'#logout'" > 
           </iframe>  -->
      <!-- <LoaderComponent v-if="GlobalAppLoading === true"/> -->

    </main>
  </div>

  <ChartsComponent v-if="acceptedCharte == false" />
  <FeedbackComponent v-if="user" :add-alert-parent="addAlert" ref="feedback" :connectedUser="user" />
</template>

@/stores/user